<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Started in the construction industry as an apprentice quantity surveyor in 1965 when he was aged 16, Dave Husband left FIFE in 1971 to work in Liverpool (Merseyside, Cheshire and North Wales).</p><br/>
<p style="text-indent: 00em;">A naive young Scotsman on a huge learning curve teased by magical scousers. When you are hard up and penniless, humour is still a form of escapism.</p><br/>
<p style="text-indent: 00em;">He saw first oil ashore in 1978 at Sullom Voe, Shetland. Shetland was a great experience. A special mention to the American coastguards.</p><br/>
<p style="text-indent: 00em;">Dave worked on contracts all over the United Kingdom. Scotland, England, Wales and Northern Ireland for the next 50 years.</p><br/>
<p style="text-indent: 00em;">Dealt with “good, bad and sometimes the nasty”. He understood the difference between fair and fare!</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3e0755c4